document.addEventListener("DOMContentLoaded", function(event) {
//SWIPER
const swiper = new Swiper('.swiper', {
  // Optional parameters
  loop: true,

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});


});

// Design by unlimited.studio – https://unlimited.studio